import { render } from "./presenterform.vue?vue&type=template&id=7c12f2fc&scoped=true"
import script from "./presenterform.vue?vue&type=script&lang=js"
export * from "./presenterform.vue?vue&type=script&lang=js"

import "./presenterform.vue?vue&type=style&index=0&id=7c12f2fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c12f2fc"

export default script